module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cz-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("合伙人积分(配送)")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "alipayform",
    attrs: {
      "action": "api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253",
      "name": "transferForm",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("消费合伙人积分（配送） : " + _vm._s(_vm.consume))])]), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("创投合伙人积分（配送） : " + _vm._s(_vm.shareholding))])]), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("网点合伙人积分（配送） : " + _vm._s(_vm.provincialShare))])]), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("高管合伙人积分（配送） : " + _vm._s(_vm.manageShare))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/account_logo.png"),
      "width": "200"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4381dc99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account-center/showMyAccount.vue
// module id = 1591
// module chunks = 1